import { render, staticRenderFns } from "./HomeVideoTutorials.vue?vue&type=template&id=2b075198&"
import script from "./HomeVideoTutorials.vue?vue&type=script&lang=js&"
export * from "./HomeVideoTutorials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports